<template>
  <el-dialog
    :title="'Nạp tiền cho đại lý'"
    :visible.sync="dialogDepositVisible"
    width="500px"
    :close-on-click-modal="false"
    @open="onOpen"
    @close="onClose"
  >
    <div class="das-form-container">
      <InfoList :columns="1">
        <InfoListLabel>{{ `Tên công ty/Đại lý` }}</InfoListLabel>
        <InfoListValue>{{ agentName }} </InfoListValue>

        <InfoListLabel>{{ `Số tiền nạp` }}</InfoListLabel>
        <InfoListValue
          ><div style="display: flex; gap: 10px">
            <VxCurrencyInput v-model="formData.amount" />
            <el-select
              v-model="formData.currency_id"
              style="width: 100px"
              placeholder=""
            >
              <el-option
                v-for="item1 in currencyOptions"
                :key="item1.id"
                :label="item1.code"
                :value="item1.id"
              >
              </el-option>
            </el-select>
          </div>
        </InfoListValue>

        <InfoListLabel>{{ `Hình thức` }}</InfoListLabel>
        <InfoListValue><span>Chuyển khoản</span></InfoListValue>

        <InfoListLabel>{{ `Tài khoản nhận` }}</InfoListLabel>
        <InfoListValue
          ><el-select v-model="formData.bank_account_id" placeholder="">
            <el-option
              v-for="option in bankAccOptions"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            /> </el-select
        ></InfoListValue>
      </InfoList>
    </div>

    <!-- Footer btns -->
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small" @click="fnDeposit">Nạp tiền</button>
        <button
          class="btn primary small outline"
          @click="dialogDepositVisible = false"
        >
          Đóng
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import InfoList from '@/components/info-list/InfoList.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'

import {
  rechargeAgentWallet,
  getTicketBankAcountListApi
} from '@/api/accounting/agent-wallet'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: { InfoList, InfoListLabel, InfoListValue },
  props: {
    agentId: {
      type: Number
    },
    agentName: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        amount: 0,
        agent_id: null,
        bank_account_id: null,
        currency_id: 5,
        method: 3
      },
      defaultFormData: {
        amount: 0,
        agent_id: null,
        bank_account_id: null,
        currency_id: 5,
        method: 3
      },

      currencyOptions: [{ id: 5, code: 'VND' }],
      bankAccOptions: []
    }
  },

  computed: {
    dialogDepositVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  async mounted() {
    await this.fnGetBankAccOptions()
  },

  methods: {
    onOpen() {
      // init data
      this.formData.agent_id = this.agentId
    },
    onClose() {
      // reset before close dialog
      this.formData = Object.assign({}, this.defaultFormData)
      this.formData.bank_account_id = this.bankAccOptions[0]?.id
    },

    // handle api call
    async fnDeposit() {
      if (this.formData.amount <= 0) {
        notifyError('amountMoneyGreatThanZero')
        return false
      }
      let res
      try {
        res = await rechargeAgentWallet(this.formData)
        notifySuccess(res.message)
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        const message = error.response?.data?.message || 'default'
        notifyError(message)
      } finally {
        this.dialogDepositVisible = false
      }
    },
    async fnGetBankAccOptions() {
      const res = await getTicketBankAcountListApi()
      this.bankAccOptions = res.data || []
      this.formData.bank_account_id = this.bankAccOptions[0]?.id
    }
  }
}
</script>
